import { v4 as uuidv4 } from 'uuid';
import { NOTIFICATION_TIMEOUT } from '../../constants/timeouts';
import { ENotificationType, INotification } from '../../types/notifications';

export const createError = (message: string, timeout: number = NOTIFICATION_TIMEOUT): INotification => {
  return {
    id: uuidv4(),
    message,
    timeout,
    type: ENotificationType.Error,
  };
};
